// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RZHf","badges":"styles_badges__qnrdc"};